import { render, staticRenderFns } from "./Aging.vue?vue&type=template&id=4fa98deb"
import script from "./Aging.vue?vue&type=script&lang=js"
export * from "./Aging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports